var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplyNewConnection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.93,
    height: 66.129,
    viewBox: "0 0 55.93 66.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.922,32.738l-6.45-6.8-6.467,6.8a9.924,9.924,0,0,0,0,13.6,8.782,8.782,0,0,0,12.917,0A9.924,9.924,0,0,0,32.922,32.738Zm-3.308,8.038H28.176v1.439a1.654,1.654,0,1,1-3.308,0V40.776H23.412a1.654,1.654,0,1,1,0-3.308h1.439V35.963a1.654,1.654,0,1,1,3.308,0V37.4H29.6a1.654,1.654,0,0,1,0,3.308Z",
    transform: "translate(11.359 16.965)",
    fill: "#1787e0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.17,63.975H4.547a1.654,1.654,0,0,1-1.654-1.191C2.413,61.13-8.685,21.436,15.843.4A1.654,1.654,0,0,1,16.984,0H54.248a1.654,1.654,0,0,1,1.29,2.7c-.149.165-13.794,17.267-15.514,37.561a1.66,1.66,0,1,1-3.308-.281c1.422-16.688,10.2-30.929,14.24-36.668H17.6C-2.565,21.154,4.2,54.018,5.837,60.667H23.17a1.654,1.654,0,1,1,0,3.308Z",
    transform: "translate(0.023 0.001)",
    fill: "#1787e0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.586,6.678H12.054a1.654,1.654,0,1,1,0-3.308H29.586a1.654,1.654,0,1,1,0,3.308Z",
    transform: "translate(6.839 2.205)",
    fill: "#1787e0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.285,10.308H8.7A1.654,1.654,0,0,1,8.7,7H26.285a1.654,1.654,0,1,1,0,3.308Z",
    transform: "translate(4.648 4.579)",
    fill: "#efc700"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.674,10.308h-6.02a1.654,1.654,0,1,1,0-3.308h6.053a1.654,1.654,0,1,1,0,3.308Z",
    transform: "translate(13.117 4.579)",
    fill: "#1787e0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.345,28.248H4.764a1.654,1.654,0,1,1,0-3.308H22.345a1.654,1.654,0,0,1,0,3.308Z",
    transform: "translate(2.072 16.311)",
    fill: "#1787e0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.774,28.248h-6.12a1.654,1.654,0,0,1,0-3.308h6.12a1.654,1.654,0,0,1,0,3.308Z",
    transform: "translate(10.501 16.311)",
    fill: "#efc700"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.377,18.308H5.324a1.654,1.654,0,1,1,0-3.308h6.053a1.654,1.654,0,1,1,0,3.308Z",
    transform: "translate(2.438 9.81)",
    fill: "#1787e0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.247,18.308H12.194a1.654,1.654,0,1,1,0-3.308h6.053a1.654,1.654,0,1,1,0,3.308Z",
    transform: "translate(6.93 9.81)",
    fill: "#1787e0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.907,18.308H18.854a1.654,1.654,0,1,1,0-3.308h6.053a1.654,1.654,0,1,1,0,3.308Z",
    transform: "translate(11.286 9.81)",
    fill: "#1787e0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.325,14.528H6.744a1.654,1.654,0,0,1,0-3.308H24.325a1.654,1.654,0,1,1,0,3.308Z",
    transform: "translate(3.366 7.338)",
    fill: "#1787e0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.235,23.248H4.654a1.654,1.654,0,0,1,0-3.308H22.235a1.654,1.654,0,1,1,0,3.308Z",
    transform: "translate(2 13.041)",
    fill: "#1787e0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyNewConnection);
export default __webpack_public_path__ + "static/media/apply_new_connection.497f2ea7392b342bdc384ad641607fc4.svg";
export { ForwardRef as ReactComponent };